module.exports = {
    env: 'prod',
    baseURL: {
        BASE_URL: process.env.REACT_APP_BASE_URL,
    },
    featureFlags: {
        ShowNflBrand: true,
        brandName: 'NFL',
    },
};
